import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Wormhole state management",
  "description": "",
  "published": "2020-06-29T00:00:00.000Z",
  "redirect_from": ["/blog/wormhole-state-management/swizec/9442"],
  "categories": "Front End, Technical",
  "hero": "./img/5ooOfMY.png"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Engineers often jump into Redux, MobX, XState, or Recoil before they really need to. That's what large orgs use so it must be right.`}</p>
    <p>{`You are not Google, Facebook, Amazon, or Uber. You're shooting yourself in the foot by blindly following their patterns. Probably.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=62AMy1QIpzk"
      }}><span parentName="a" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "890px",
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.05381165919282%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20112v112h401V0H0v112m182-92c0%203%200%203-1%202v-3l-1-1c-1-1-1%200-1%202v4l-1-4-2-3v4c-1%205-2%206-2%203l-1-2-1-1-1-2v2l-1%201h-1l-1%202-1%201h2l1%202h-2c-1%201-2-1-3-3-2-5-5-7-4-3v1l-2-1%201%203%201%201h-2c-2-3-3-1%200%201l1%203-3-2c0-2-2-3-2-3l3%206v1c-1%200-2%201-1%202l-1%201v2l2%201-3%201-5-3c-5-3-7-3-3%201l3%203-4-1-4-2v1c3%202-1%201-7-2l-7-3%202%202c5%203%204%204-1%202l-5-2%203%202c2%201%202%201%201%202v3h3l1%201h1l8%204c10%203%2022%203%2066-1%2016-2%2030-6%2047-14%209-5%2011-6%209-6-2-1-4%200-6%201-10%204-18%208-19%207l-1%201-3%201-4%202-2%201c-1%200-1-1%201-2%203-1%203-2%202-2l-2-2-1-3v1l-2%203c-3%202-4%203-4%201h-3l-5%201c-1%201-2%202-3%201-3%200-3-2%200-2%202%200%202%200%201-1-2-1-4%200-4%202l-3%201c-3%200-4-1-2-2%202-2%201-3-4-2l-4-1%204-1h4l-3-1-3-1%202-1c2-1%202-1%200-1l-2%202c-1%202-5%201-5-2%201-2%200-2-1-1l-2-1-1-1-1-3v-3l-1%201v2l-1%204c0%204-2%201-2-4l-1-4v4m-40%2076l-2%203c0%202%203%205%206%205%203%201%205%203%204%204%200%202-5%201-6%200%200-2-4-2-4-1%200%203%204%205%208%205%208%200%209-9%200-11-3%200-5-2-3-3s3-1%204%201h5c0-5-9-6-12-3M20%2096l3%209c1%206%202%207%204%207%201%200%202-1%202-4%202-6%203-7%204-1%201%204%202%205%203%205%202%200%203-2%205-9l2-8h-2c-2%200-3%202-3%206-2%205-3%205-4-2%200-3-1-4-2-4-2%200-3%201-4%205l-2%205-1-6-3-4-2%201m67%208c0%207%200%208%202%208%201%200%202-2%202-5%200-4%200-5%202-5s2%201%202%205%200%205%202%205%202-1%202-5c0-6-2-9-6-8-2%201-3%201-2-2%200-2%200-2-2-2s-2%201-2%209m118-1c0%208%200%209%202%209s2-1%202-5l1-5%201%205c3%207%205%207%207%200l2-4v4c0%204%200%205%202%205s2-1%202-8v-9h-3c-2%200-3%201-3%202l-2%206-1%203-2-5c-1-5-2-6-5-6h-3v8m-48-5l-1%201-1%202%201%201%201%205c0%204%201%205%203%205l3-1h1l6%201h6l-1-6-1-6h-9c-2%202-1%203%203%203h3l-2%201-5%203c-3%203-4%203-4-1%200-3%200-4%202-4l1-1-1-2-2-1-1-2-2%202m-113%203c-3%202-3%207%200%209%203%203%208%202%209%200%205-7-2-14-9-9m22%205l1%206c1%200%202-1%202-5%200-3%201-5%202-5%202%200%202%201%202%205s0%205%202%205%202-1%202-5c0-3%201-5%202-5%202%200%202%201%202%205s0%205%202%205%202-1%202-5l-1-7h-8l-6-1h-4v7m36-4c-4%204-1%2010%204%2010s7-2%207-6c0-7-7-9-11-4m20%200c-2%203-3%205%200%208%202%203%207%203%2010%200%201-2%201-2-1-2l-3%201h-3c-1-1-1-2%203-2%205-1%206-3%203-6s-6-3-9%201m65-1c-2%202-2%207%200%209%202%203%2010%202%2010-1h-7c-2-1-2-2%203-2%204%200%204-1%204-2-1-6-7-8-10-4m40%200l-1%202h4c5-1%205%200%200%202-3%200-3%201-3%204%200%202%200%203%205%203h6v-5l-1-7c-2-2-7-1-10%201m13%205c0%205%200%206%202%206s2-1%202-5c0-3%201-4%202-4s2%201%202%204c0%204%200%205%202%205s2-1%202-5c0-7-1-8-7-8h-5v7m15-6c-2%202-1%203%203%203%204-1%204%201%200%201-4%201-5%203-5%206%201%202%202%202%207%202h6l-1-5-1-7h-9m14%201c-4%204-1%2012%204%2011h3c0%202-3%202-6%201s-4%201-1%203c3%201%206%201%209-1l1-8%201-7-5-1c-3%200-5%200-6%202m14%200c-3%203-2%207%200%209s7%202%209%200%201-3-2-1c-3%201-5%200-5-1l4-1c5%200%206-1%204-4-2-5-8-5-10-2m12%205c0%205%200%206%202%206l2-2%201-3v-4c2-2%203%200%203%205%200%203%200%204%202%204s2-1%202-5%200-5%202-5c1%200%202%202%202%205%200%207%203%207%203%200%201-7%200-8-11-8h-8v7m23-5c-2%201-3%207%200%209%201%202%207%203%209%201s1-3-3-2l-4-1%204-1c4%200%204%200%204-2%200-5-5-8-10-4m12%205c0%205%200%206%202%206%201%200%202-1%202-5%200-5%200-6%202-5s2%202%202%205c0%204%200%205%202%205s2-1%202-5c0-7-1-8-7-8h-5v7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4890b4e64ac13b01f98e41b301b22830/ca0a1/5ooOfMY.webp 223w", "/static/4890b4e64ac13b01f98e41b301b22830/75680/5ooOfMY.webp 445w", "/static/4890b4e64ac13b01f98e41b301b22830/8d1ba/5ooOfMY.webp 890w", "/static/4890b4e64ac13b01f98e41b301b22830/3838e/5ooOfMY.webp 1335w", "/static/4890b4e64ac13b01f98e41b301b22830/e11e5/5ooOfMY.webp 1780w", "/static/4890b4e64ac13b01f98e41b301b22830/8e90b/5ooOfMY.webp 1915w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/4890b4e64ac13b01f98e41b301b22830/e92b6/5ooOfMY.png 223w", "/static/4890b4e64ac13b01f98e41b301b22830/e66bf/5ooOfMY.png 445w", "/static/4890b4e64ac13b01f98e41b301b22830/4ef49/5ooOfMY.png 890w", "/static/4890b4e64ac13b01f98e41b301b22830/4e814/5ooOfMY.png 1335w", "/static/4890b4e64ac13b01f98e41b301b22830/701e9/5ooOfMY.png 1780w", "/static/4890b4e64ac13b01f98e41b301b22830/c72f7/5ooOfMY.png 1915w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/4890b4e64ac13b01f98e41b301b22830/4ef49/5ooOfMY.png",
              "alt": "5ooOfMY",
              "title": "5ooOfMY",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
    `}</span></a></p>
    <p><em parentName="p">{`This article is based on my talk at Reactive Conf Meetup #4 in May`}</em>{` 👆`}</p>
    <p>{`The Wormhole State Management pattern stems from a single idea: use the least complex machinery that solves your problem.`}</p>
    <p>{`That's why it's a pattern, not a library.`}</p>
    <p><em parentName="p">{`You`}</em>{` have control to make it as simple or complex as fits the problem. `}<em parentName="p">{`You`}</em>{` can scale it from small examples to large codebases.`}</p>
    <p>{`It's the pattern behind libraries like `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/useAuth"
      }}>{`useAuth`}</a>{` and every React app – big or small – that I've built in the past 18 months. And now it has a name ✌️`}</p>
    <p>{`Here's how it works`}</p>
    <h2 {...{
      "id": "keep-local-state-local"
    }}>{`Keep local state local`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/742bb671c3fa65582dde23cf89890d00/14747/aUec58X.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.05381165919282%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'223\\'%20viewBox=\\'0%200%20400%20223\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20112v111h401V0H0v112m128-90c-1%203%200%2010%202%2010%202%201%204%200%202-1s-1-6%201-6l1%203c0%203%201%204%202%204%202%201%204%200%202-1v-6l1%202c0%203%202%206%204%206s5-2%204-3h-4c-2-1-1-2%202-2s4-1%202-3c-1-2-5-3-6-1-1%201-4-1-4-3l-1-1-2%202-1%201-2-1c0-3-3-2-3%200m-82%202v4c0%204%201%206%202%202%201-6%204-7%204-1%201%204%202%204%203%200%200-2%201-3%202-3l1%203c1%204%202%204%203%200%200-5%202-5%203%200%200%205%202%204%202-1v-4l-10-1-10%201m61%206c0%205%200%206%202%206l1-2c0-1%201-2%202-1l3-2c1-2%201-2%203%200%201%202%202%202%205%201%203%200%203%200%203-4s-1-4-4-4l-4%201h2l3%201-2%201-3%201-2-2c-1-3-1-3-5-3h-4v7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/742bb671c3fa65582dde23cf89890d00/ca0a1/aUec58X.webp 223w", "/static/742bb671c3fa65582dde23cf89890d00/75680/aUec58X.webp 445w", "/static/742bb671c3fa65582dde23cf89890d00/8d1ba/aUec58X.webp 890w", "/static/742bb671c3fa65582dde23cf89890d00/3838e/aUec58X.webp 1335w", "/static/742bb671c3fa65582dde23cf89890d00/e11e5/aUec58X.webp 1780w", "/static/742bb671c3fa65582dde23cf89890d00/05270/aUec58X.webp 1914w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/742bb671c3fa65582dde23cf89890d00/e92b6/aUec58X.png 223w", "/static/742bb671c3fa65582dde23cf89890d00/e66bf/aUec58X.png 445w", "/static/742bb671c3fa65582dde23cf89890d00/4ef49/aUec58X.png 890w", "/static/742bb671c3fa65582dde23cf89890d00/4e814/aUec58X.png 1335w", "/static/742bb671c3fa65582dde23cf89890d00/701e9/aUec58X.png 1780w", "/static/742bb671c3fa65582dde23cf89890d00/14747/aUec58X.png 1914w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/742bb671c3fa65582dde23cf89890d00/4ef49/aUec58X.png",
              "alt": "aUec58X",
              "title": "aUec58X",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`What's the smallest amount of sharing you can get away with?`}</p>
    <p>{`Keep your state there. As close to where it's used as possible.`}</p>
    <p>{`If a single component cares, use that. If a few components care, share it with props. If many components care, put it in context.`}</p>
    <p>{`Context is like a wormhole. It bends your component tree so pieces far apart can touch.`}</p>
    <p>{`Leverage custom hooks to make this easy.`}</p>
    <h2 {...{
      "id": "keep-state-simple"
    }}>{`Keep state simple`}</h2>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "890px",
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/static/d3651afff10bc3a2fa084ced91651a5d/ec09f/ukioN5r.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "56.05381165919282%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'224\\'%20viewBox=\\'0%200%20400%20224\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20112v112h401V0H0v112m128-89c-1%204%200%209%203%2010l2-1-1-1-1-2c0-2%201-3%202-3l1%204c0%203%200%203%203%203%202%200%202%200%201-1v-6l1%202c0%204%204%207%207%205s2-3-1-2l-3-1%203-1c3%200%204-2%202-4h-7c0%201-3-1-3-3l-1-1-2%202-1%201-2-1c0-3-3-2-3%200m-82%206l1%204%201-2c0-3%202-5%203-5l1%204c0%204%203%204%203%200%201-5%203-5%203-1%200%203%200%204%202%204l1-4c0-4%202-4%203%201%200%203%203%204%203%201%200-7%200-7-11-7H46v5m61%201c0%206%202%209%203%205l2-2%203-1%202-1c0%202%203%203%206%202%203%200%203-1%203-4%200-4-1-4-4-4l-4%201h2l3%201-2%201-3%201-1-2c-2-3-2-3-6-3h-4v6\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d3651afff10bc3a2fa084ced91651a5d/ca0a1/ukioN5r.webp 223w", "/static/d3651afff10bc3a2fa084ced91651a5d/75680/ukioN5r.webp 445w", "/static/d3651afff10bc3a2fa084ced91651a5d/8d1ba/ukioN5r.webp 890w", "/static/d3651afff10bc3a2fa084ced91651a5d/3838e/ukioN5r.webp 1335w", "/static/d3651afff10bc3a2fa084ced91651a5d/e11e5/ukioN5r.webp 1780w", "/static/d3651afff10bc3a2fa084ced91651a5d/3d7de/ukioN5r.webp 1916w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/static/d3651afff10bc3a2fa084ced91651a5d/e92b6/ukioN5r.png 223w", "/static/d3651afff10bc3a2fa084ced91651a5d/e66bf/ukioN5r.png 445w", "/static/d3651afff10bc3a2fa084ced91651a5d/4ef49/ukioN5r.png 890w", "/static/d3651afff10bc3a2fa084ced91651a5d/4e814/ukioN5r.png 1335w", "/static/d3651afff10bc3a2fa084ced91651a5d/701e9/ukioN5r.png 1780w", "/static/d3651afff10bc3a2fa084ced91651a5d/ec09f/ukioN5r.png 1916w"],
              "sizes": "(max-width: 890px) 100vw, 890px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/static/d3651afff10bc3a2fa084ced91651a5d/4ef49/ukioN5r.png",
              "alt": "ukioN5r",
              "title": "ukioN5r",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`What's the simplest state you can get away with?`}</p>
    <p>{`Do that. You can always change it later.`}</p>
    <p>{`You can always make a simple codebase complex, but you can't make a complex codebase simple.`}</p>
    <p>{`Your code becomes easier to understand, too.`}</p>
    <p>{`Imagine stepping into a component you haven't seen in 2 years. What happens?`}</p>
    <p>{`First you read the component code. It kind of makes sense.`}</p>
    <p>{`Then you travel 5 files into a different directory and learn about how its state works.`}</p>
    <p>{`3 more files away is a bit more of its state.`}</p>
    <p>{`Another 10 files away are all the side-effects from who knows what.`}</p>
    <p>{`Before you know it, you've read most of the codebase and you're still not sure how this component works. You try to isolate it to run some tests and realize it needs the whole state management jungle to work.`}</p>
    <p>{`You wanted a banana. You got `}<a parentName="p" {...{
        "href": "https://www.johndcook.com/blog/2011/07/19/you-wanted-banana/"
      }}>{`a gorilla holding the banana and the entire jungle`}</a>{`.`}</p>
    <p><img parentName="p" {...{
        "src": "/f47c5ef6a831726be5a2430fc90831de/media-iXOoi6i2l9PZvCN0zU-giphy-downsized-medium.gif",
        "alt": "gorilla_holding_banana giphy"
      }}></img></p>
    <h2 {...{
      "id": "an-example"
    }}>{`An example`}</h2>
    <p>{`Follow along as I build a contrived click counter. The Wormhole State Management pattern is best explained through examples ✌️`}</p>
    <h3 {...{
      "id": "step-1"
    }}>{`step 1`}</h3>
    <p>{`We start with `}<inlineCode parentName="p">{`useState`}</inlineCode>{` because it's the simplest.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/wormhole-state-pattern-1-8i1zv?file=/src/App.js"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e688f0fcde0836bcb464fef374074d56/ca0a1/techletter.app-screenshot-1593447834993.webp 223w", "/static/e688f0fcde0836bcb464fef374074d56/75680/techletter.app-screenshot-1593447834993.webp 445w", "/static/e688f0fcde0836bcb464fef374074d56/0ba47/techletter.app-screenshot-1593447834993.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/e688f0fcde0836bcb464fef374074d56/e92b6/techletter.app-screenshot-1593447834993.png 223w", "/static/e688f0fcde0836bcb464fef374074d56/e66bf/techletter.app-screenshot-1593447834993.png 445w", "/static/e688f0fcde0836bcb464fef374074d56/6af66/techletter.app-screenshot-1593447834993.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/e688f0fcde0836bcb464fef374074d56/6af66/techletter.app-screenshot-1593447834993.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20ClickCounter%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%5Bcount%2C%20setCount%5D%20%3D%20useState(0)%3B%0A%0A%20%20function%20onClick()%20%7B%0A%20%20%20%20setCount(count%20%3D%3E%20count%20%2B%201)%3B%0A%20%20%7D%0A%0A%20%20return%20%3Cbutton%20onClick%3D%7BonClick%7D%3E%7Bcount%7D%20%2B1%3C%2Fbutton%3E%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "542px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "60.98654708520179%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'244\\'%20viewBox=\\'0%200%20400%20244\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2038a2920%202920%200%20001%20171l175%201%20175-1%201-85V38c-1-3-351-3-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fd8f2f1160eb5c38e7e460fe124ec6f6/ca0a1/techletter.app-screenshot-1593447820603.webp 223w", "/static/fd8f2f1160eb5c38e7e460fe124ec6f6/75680/techletter.app-screenshot-1593447820603.webp 445w", "/static/fd8f2f1160eb5c38e7e460fe124ec6f6/3f954/techletter.app-screenshot-1593447820603.webp 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/fd8f2f1160eb5c38e7e460fe124ec6f6/e92b6/techletter.app-screenshot-1593447820603.png 223w", "/static/fd8f2f1160eb5c38e7e460fe124ec6f6/e66bf/techletter.app-screenshot-1593447820603.png 445w", "/static/fd8f2f1160eb5c38e7e460fe124ec6f6/c0388/techletter.app-screenshot-1593447820603.png 542w"],
                "sizes": "(max-width: 542px) 100vw, 542px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/fd8f2f1160eb5c38e7e460fe124ec6f6/c0388/techletter.app-screenshot-1593447820603.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><inlineCode parentName="p">{`count`}</inlineCode>{` holds the current number of clicks, `}<inlineCode parentName="p">{`setCount`}</inlineCode>{` lets us update the value on every click.`}</p>
    <p>{`Simple enough.`}</p>
    <p>{`Presentation isn't the prettiest though. Let's improve it with a custom button component and some nesting.`}</p>
    <h3 {...{
      "id": "step-2"
    }}>{`step 2`}</h3>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/wormhole-state-pattern-2-kg697?file=/src/App.js"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/25838791f64b1380a642eb9063364199/ca0a1/techletter.app-screenshot-1593447834188.webp 223w", "/static/25838791f64b1380a642eb9063364199/75680/techletter.app-screenshot-1593447834188.webp 445w", "/static/25838791f64b1380a642eb9063364199/0ba47/techletter.app-screenshot-1593447834188.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/25838791f64b1380a642eb9063364199/e92b6/techletter.app-screenshot-1593447834188.png 223w", "/static/25838791f64b1380a642eb9063364199/e66bf/techletter.app-screenshot-1593447834188.png 445w", "/static/25838791f64b1380a642eb9063364199/6af66/techletter.app-screenshot-1593447834188.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/25838791f64b1380a642eb9063364199/6af66/techletter.app-screenshot-1593447834188.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We created a reusable `}<inlineCode parentName="p">{`PrettyButton`}</inlineCode>{` that ensures every button in our app looks fabulous. Nice and pink.`}</p>
    <p>{`State remains in the `}<inlineCode parentName="p">{`ClickCounter`}</inlineCode>{` component.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20ClickCounter%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%5Bcount%2C%20setCount%5D%20%3D%20useState(0)%3B%0A%0A%20%20function%20onClick()%20%7B%0A%20%20%20%20setCount(count%20%3D%3E%20count%20%2B%201)%3B%0A%20%20%7D%0A%0A%20%20return%20(%0A%20%20%20%20%3C%3E%0A%20%20%20%20%20%20%3Cp%3EYou%20have%20clicked%20buttons%20%7Bcount%7D%20times%3C%2Fp%3E%0A%20%20%20%20%20%20%3Cdiv%20style%3D%7B%7B%20textAlign%3A%20%22right%22%20%7D%7D%3E%0A%20%20%20%20%20%20%20%20%3CPrettyButton%20onClick%3D%7BonClick%7D%3E%2B1%3C%2FPrettyButton%3E%0A%20%20%20%20%20%20%3C%2Fdiv%3E%0A%20%20%20%20%3C%2F%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "558px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "81.61434977578475%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'327\\'%20viewBox=\\'0%200%20400%20327\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2035l-5%201-1%20127%201%20130c2%202%20350%202%20352%200l1-130V36l-6-1H29\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d9de9a725a52b68049af41bcb8ef30bc/ca0a1/techletter.app-screenshot-1593447815330.webp 223w", "/static/d9de9a725a52b68049af41bcb8ef30bc/75680/techletter.app-screenshot-1593447815330.webp 445w", "/static/d9de9a725a52b68049af41bcb8ef30bc/1c397/techletter.app-screenshot-1593447815330.webp 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/d9de9a725a52b68049af41bcb8ef30bc/e92b6/techletter.app-screenshot-1593447815330.png 223w", "/static/d9de9a725a52b68049af41bcb8ef30bc/e66bf/techletter.app-screenshot-1593447815330.png 445w", "/static/d9de9a725a52b68049af41bcb8ef30bc/42a8d/techletter.app-screenshot-1593447815330.png 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/d9de9a725a52b68049af41bcb8ef30bc/42a8d/techletter.app-screenshot-1593447815330.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`This is the least amount of state sharing necessary. We kept state simple, too.`}</p>
    <p>{`The counter component cares about clicks and counts so it passes a callback into the button as a prop. Function gets called, state updates, component re-renders.`}</p>
    <p>{`No complex machinery required.`}</p>
    <h2 {...{
      "id": "step-3"
    }}>{`step 3`}</h2>
    <p>{`What if our state is more complex? We have 2 items that belong together.`}</p>
    <p>{`You can keep complex values in your state. Works great.`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/wormhole-state-pattern-3-eygcf?file=/src/App.js"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/839b20a482ad92e67937845a6da81bce/ca0a1/techletter.app-screenshot-1593447835849.webp 223w", "/static/839b20a482ad92e67937845a6da81bce/75680/techletter.app-screenshot-1593447835849.webp 445w", "/static/839b20a482ad92e67937845a6da81bce/0ba47/techletter.app-screenshot-1593447835849.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/839b20a482ad92e67937845a6da81bce/e92b6/techletter.app-screenshot-1593447835849.png 223w", "/static/839b20a482ad92e67937845a6da81bce/e66bf/techletter.app-screenshot-1593447835849.png 445w", "/static/839b20a482ad92e67937845a6da81bce/6af66/techletter.app-screenshot-1593447835849.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/839b20a482ad92e67937845a6da81bce/6af66/techletter.app-screenshot-1593447835849.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20ClickCounter%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%5Bcount%2C%20setCount%5D%20%3D%20useState(%7B%20A%3A%200%2C%20B%3A%200%20%7D)%3B%0A%0A%20%20function%20onClickA()%20%7B%0A%20%20%20%20setCount(count%20%3D%3E%20%7B%0A%20%20%20%20%20%20return%20%7B%20...count%2C%20A%3A%20count.A%20%2B%201%20%7D%3B%0A%20%20%20%20%7D)%3B%0A%20%20%7D%0A%0A%20%20function%20onClickB()%20%7B%0A%20%20%20%20setCount(count%20%3D%3E%20%7B%0A%20%20%20%20%20%20return%20%7B%20...count%2C%20B%3A%20count.B%20%2B%201%20%7D%3B%0A%20%20%20%20%7D)%3B%0A%20%20%7D%0A%0A%20%20return%20(%0A%20%20%20%20%3C%3E%0A%20%20%20%20%20%20%3Cp%3E%0A%20%20%20%20%20%20%20%20You%20have%20clicked%20buttons%20A%3A%20%7Bcount.A%7D%2C%20B%3A%20%7Bcount.B%7D%20times%0A%20%20%20%20%20%20%3C%2Fp%3E%0A%20%20%20%20%20%20%3Cdiv%20style%3D%7B%7B%20textAlign%3A%20%22right%22%20%7D%7D%3E%0A%20%20%20%20%20%20%20%20%3CPrettyButton%20onClick%3D%7BonClickA%7D%3EA%20%2B1%3C%2FPrettyButton%3E%0A%20%20%20%20%20%20%20%20%26nbsp%3B%0A%20%20%20%20%20%20%20%20%3CPrettyButton%20onClick%3D%7BonClickB%7D%3EB%20%2B1%3C%2FPrettyButton%3E%0A%20%20%20%20%20%20%3C%2Fdiv%3E%0A%20%20%20%20%3C%2F%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "622px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "108.07174887892377%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'432\\'%20viewBox=\\'0%200%20400%20432\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2033a12174%2012174%200%20001%20369h356a12174%2012174%200%20001-369c-1-3-357-3-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/140724e7ff78bef0e2dc9cf5ee9399f8/ca0a1/techletter.app-screenshot-1593447820654.webp 223w", "/static/140724e7ff78bef0e2dc9cf5ee9399f8/75680/techletter.app-screenshot-1593447820654.webp 445w", "/static/140724e7ff78bef0e2dc9cf5ee9399f8/5bf66/techletter.app-screenshot-1593447820654.webp 622w"],
                "sizes": "(max-width: 622px) 100vw, 622px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/140724e7ff78bef0e2dc9cf5ee9399f8/e92b6/techletter.app-screenshot-1593447820654.png 223w", "/static/140724e7ff78bef0e2dc9cf5ee9399f8/e66bf/techletter.app-screenshot-1593447820654.png 445w", "/static/140724e7ff78bef0e2dc9cf5ee9399f8/604ec/techletter.app-screenshot-1593447820654.png 622w"],
                "sizes": "(max-width: 622px) 100vw, 622px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/140724e7ff78bef0e2dc9cf5ee9399f8/604ec/techletter.app-screenshot-1593447820654.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We've split `}<inlineCode parentName="p">{`count`}</inlineCode>{` into an object – `}<inlineCode parentName="p">{`{ A, B }`}</inlineCode>{`.`}</p>
    <p>{`Now a single piece of state can hold multiple values. Separate counts for separate button clicks.`}</p>
    <p>{`React uses JavaScript equality to detect changes for re-renders so you have to make copies of full state on every update. This gets slow around 10,000 or so elements.`}</p>
    <p>{`You can use `}<inlineCode parentName="p">{`useReducer`}</inlineCode>{` here, too. Especially when your state becomes more complex and items often update separately.`}</p>
    <p>{`Similar state using `}<inlineCode parentName="p">{`useReducer`}</inlineCode>{` would look something like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20%5Bstate%2C%20dispatch%5D%20%3D%20useReducer((action%2C%20state)%20%3D%3E%20%7B%0A%09switch%20(action.type)%20%7B%0A%09%09case%20'A'%3A%0A%09%09%09return%20%7B%20...state%2C%20A%3A%20state.A%20%2B%201%20%7D%0A%09%09case%20'B'%3A%0A%09%09%09return%20%7B%20...state%2C%20A%3A%20state.A%20%2B%201%20%7D%0A%09%7D%0A%7D%2C%20%7B%20A%3A%200%2C%20B%3A%200%7D)%0A%0Afunction%20onClickA()%20%7B%0A%09dispatch(%7B%20type%3A%20'A'%20%7D)%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "558px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "68.60986547085201%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'275\\'%20viewBox=\\'0%200%20400%20275\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035c-2%202-1%20204%201%20206s348%202%20350%200%203-204%201-206-350-2-352%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/98c1d152ecb2ebc3cfbd13a25630818f/ca0a1/techletter.app-screenshot-1593447820497.webp 223w", "/static/98c1d152ecb2ebc3cfbd13a25630818f/75680/techletter.app-screenshot-1593447820497.webp 445w", "/static/98c1d152ecb2ebc3cfbd13a25630818f/1c397/techletter.app-screenshot-1593447820497.webp 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/98c1d152ecb2ebc3cfbd13a25630818f/e92b6/techletter.app-screenshot-1593447820497.png 223w", "/static/98c1d152ecb2ebc3cfbd13a25630818f/e66bf/techletter.app-screenshot-1593447820497.png 445w", "/static/98c1d152ecb2ebc3cfbd13a25630818f/42a8d/techletter.app-screenshot-1593447820497.png 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/98c1d152ecb2ebc3cfbd13a25630818f/42a8d/techletter.app-screenshot-1593447820497.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The more complex your state, the more this makes sense.`}</p>
    <p>{`But I think those switch statements get messy fast and your callback functions are already actions anyway.`}</p>
    <h2 {...{
      "id": "step-4"
    }}>{`step 4`}</h2>
    <p>{`What if we want 2 buttons to update the same state?`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/wormhole-state-pattern-4-czh8n?file=/src/App.js"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed1eb782390f42a27adfb58ebefe96a9/ca0a1/techletter.app-screenshot-1593447834369.webp 223w", "/static/ed1eb782390f42a27adfb58ebefe96a9/75680/techletter.app-screenshot-1593447834369.webp 445w", "/static/ed1eb782390f42a27adfb58ebefe96a9/0ba47/techletter.app-screenshot-1593447834369.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ed1eb782390f42a27adfb58ebefe96a9/e92b6/techletter.app-screenshot-1593447834369.png 223w", "/static/ed1eb782390f42a27adfb58ebefe96a9/e66bf/techletter.app-screenshot-1593447834369.png 445w", "/static/ed1eb782390f42a27adfb58ebefe96a9/6af66/techletter.app-screenshot-1593447834369.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ed1eb782390f42a27adfb58ebefe96a9/6af66/techletter.app-screenshot-1593447834369.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You can pass both the `}<inlineCode parentName="p">{`count`}</inlineCode>{` and `}<inlineCode parentName="p">{`setCount`}</inlineCode>{` to your components as props. But this is getting messy.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20AlternativeClick%20%3D%20(%7B%20count%2C%20setCount%20%7D)%20%3D%3E%20%7B%0A%20%20function%20onClick()%20%7B%0A%20%20%20%20setCount(count%20%3D%3E%20%7B%0A%20%20%20%20%20%20return%20%7B%20...count%2C%20B%3A%20count.B%20%2B%201%20%7D%3B%0A%20%20%20%20%7D)%3B%0A%20%20%7D%0A%0A%20%20return%20(%0A%20%20%20%20%3Cdiv%20style%3D%7B%7B%20textAlign%3A%20%22left%22%20%7D%7D%3E%0A%20%20%20%20%20%20You%20can%20also%20update%20B%20here%0A%20%20%20%20%20%20%3Cbr%20%2F%3E%0A%20%20%20%20%20%20%3CPrettyButton%20onClick%3D%7BonClick%7D%3EB%20%2B1%3C%2FPrettyButton%3E%0A%20%20%20%20%20%20%3Cp%3EIt's%20%7Bcount.B%7D%20btw%3C%2Fp%3E%0A%20%20%20%20%3C%2Fdiv%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "558px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "81.61434977578475%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'327\\'%20viewBox=\\'0%200%20400%20327\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M29%2035l-5%201-1%20127%201%20130c2%202%20350%202%20352%200l1-130V36l-6-1H29\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4a3f4d5611af99a69eebd858616cbd8d/ca0a1/techletter.app-screenshot-1593447820337.webp 223w", "/static/4a3f4d5611af99a69eebd858616cbd8d/75680/techletter.app-screenshot-1593447820337.webp 445w", "/static/4a3f4d5611af99a69eebd858616cbd8d/1c397/techletter.app-screenshot-1593447820337.webp 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/4a3f4d5611af99a69eebd858616cbd8d/e92b6/techletter.app-screenshot-1593447820337.png 223w", "/static/4a3f4d5611af99a69eebd858616cbd8d/e66bf/techletter.app-screenshot-1593447820337.png 445w", "/static/4a3f4d5611af99a69eebd858616cbd8d/42a8d/techletter.app-screenshot-1593447820337.png 558w"],
                "sizes": "(max-width: 558px) 100vw, 558px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/4a3f4d5611af99a69eebd858616cbd8d/42a8d/techletter.app-screenshot-1593447820337.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We've created a component that's hard to move and needs to understand too much of parent logic. Concerns are split, abstractions are weird, and we've created a mess.`}</p>
    <p>{`You can fix it a little by passing just the parts of state it needs and a more customized `}<inlineCode parentName="p">{`setCount`}</inlineCode>{`. But that's a lot of work.`}</p>
    <h3 {...{
      "id": "step-5"
    }}>{`step 5`}</h3>
    <p>{`Instead, you can use a wormhole to share state with a custom hook. 🤩`}</p>
    <p><a parentName="p" {...{
        "href": "https://codesandbox.io/s/wormhole-state-pattern-5-j4w5e?file=/src/App.js"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "640px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "54.26008968609865%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'217\\'%20viewBox=\\'0%200%20400%20217\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M0%20109v108h401V0H0v109m229%204v98h171V15H229v98\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c496cfe094587eebf1edc751fa3192f2/ca0a1/techletter.app-screenshot-1593447835626.webp 223w", "/static/c496cfe094587eebf1edc751fa3192f2/75680/techletter.app-screenshot-1593447835626.webp 445w", "/static/c496cfe094587eebf1edc751fa3192f2/0ba47/techletter.app-screenshot-1593447835626.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/c496cfe094587eebf1edc751fa3192f2/e92b6/techletter.app-screenshot-1593447835626.png 223w", "/static/c496cfe094587eebf1edc751fa3192f2/e66bf/techletter.app-screenshot-1593447835626.png 445w", "/static/c496cfe094587eebf1edc751fa3192f2/6af66/techletter.app-screenshot-1593447835626.png 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/c496cfe094587eebf1edc751fa3192f2/6af66/techletter.app-screenshot-1593447835626.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You now have 2 independent components sharing state. Put them anywhere in your codebase and it Just Works™.`}</p>
    <p>{`Need to access shared state somewhere else? Add the `}<inlineCode parentName="p">{`useSharedCount`}</inlineCode>{` hook and voila.`}</p>
    <p>{`Here's how this part works.`}</p>
    <p>{`We have a context provider with some machinery inside:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=export%20const%20SharedCountProvider%20%3D%20(%7B%20children%20%7D)%20%3D%3E%20%7B%0A%20%20%2F%2F%20replace%20with%20useReducer%20for%20more%20flexiblity%0A%20%20const%20%5Bstate%2C%20setState%5D%20%3D%20useState(defaultState)%3B%0A%0A%20%20const%20%5BcontextValue%2C%20setContextValue%5D%20%3D%20useState(%7B%0A%20%20%20%20state%2C%0A%20%20%20%20%2F%2F%20dispatch%20%2F%2F%20from%20your%20reducer%0A%20%20%20%20%2F%2F%20this%20is%20where%20a%20reducer%20comes%20handy%20when%20this%20grows%0A%20%20%20%20setSharedCount%3A%20(key%2C%20val)%20%3D%3E%20%7B%0A%20%20%20%20%20%20setState(state%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%20...state%2C%20%5Bkey%5D%3A%20val%20%7D%3B%0A%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%7D%0A%20%20%20%20%2F%2F%20other%20stuff%20you%20need%20in%20context%0A%20%20%7D)%3B%0A%0A%20%20%2F%2F%20avoids%20deep%20re-renders%0A%20%20%2F%2F%20when%20instances%20of%20stuff%20in%20context%20change%0A%20%20useEffect(()%20%3D%3E%20%7B%0A%20%20%20%20setContextValue(currentValue%20%3D%3E%20(%7B%0A%20%20%20%20%20%20...currentValue%2C%0A%20%20%20%20%20%20state%0A%20%20%20%20%7D))%3B%0A%20%20%7D%2C%20%5Bstate%5D)%3B%0A%0A%20%20return%20(%0A%20%20%20%20%3CSharedCountContext.Provider%20value%3D%7BcontextValue%7D%3E%0A%20%20%20%20%20%20%7Bchildren%7D%0A%20%20%20%20%3C%2FSharedCountContext.Provider%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "566px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "128.2511210762332%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'513\\'%20viewBox=\\'0%200%20400%20513\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M23%2036c-1%203-1%20442%201%20443%202%203%20350%203%20352%200%202-1%202-440%201-443S24%2033%2023%2036\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/af91fe62b522a538a9f327fce9816f02/ca0a1/techletter.app-screenshot-1593447820287.webp 223w", "/static/af91fe62b522a538a9f327fce9816f02/75680/techletter.app-screenshot-1593447820287.webp 445w", "/static/af91fe62b522a538a9f327fce9816f02/3161c/techletter.app-screenshot-1593447820287.webp 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/af91fe62b522a538a9f327fce9816f02/e92b6/techletter.app-screenshot-1593447820287.png 223w", "/static/af91fe62b522a538a9f327fce9816f02/e66bf/techletter.app-screenshot-1593447820287.png 445w", "/static/af91fe62b522a538a9f327fce9816f02/6fe44/techletter.app-screenshot-1593447820287.png 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/af91fe62b522a538a9f327fce9816f02/6fe44/techletter.app-screenshot-1593447820287.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The context provider uses a rich `}<inlineCode parentName="p">{`state`}</inlineCode>{` variable to keep your state. This is `}<inlineCode parentName="p">{`{ A, B }`}</inlineCode>{` for us.`}</p>
    <p>{`The `}<inlineCode parentName="p">{`contextValue`}</inlineCode>{` is a richer piece of state that also holds everything you need to manipulate that state. Often this would be a `}<inlineCode parentName="p">{`dispatch`}</inlineCode>{` method from your reducer, or custom state setters like we have here.`}</p>
    <p>{`Our `}<inlineCode parentName="p">{`setSharedCount`}</inlineCode>{` method gets a `}<inlineCode parentName="p">{`key`}</inlineCode>{` and `}<inlineCode parentName="p">{`val`}</inlineCode>{` and updates that part of state.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=%2F%2F%20set%20count.B%20to%2010%0AsetSharedCount('B'%2C%2010)"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "286px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "71.30044843049328%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'285\\'%20viewBox=\\'0%200%20400%20285\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M47%2071c-2%202-2%203-2%2074%200%2076%200%2073%205%2076%203%202%20298%202%20301%200%205-3%205%200%205-76%200-71%200-72-2-74l-2-3H49l-2%203m50%2021c-4%204-3%209%201%2012%205%203%2013-1%2013-7%200-7-10-11-14-5m30-2c-7%203-5%2013%203%2015%207%201%2011-8%206-14-3-2-5-2-9-1m121%2088v7h4c3%200%204-1%205-2%201-2%200-5-1-5v-2c2-3%200-5-5-5h-3v7\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/59b33ab01b8e408e98b631b3c2ee4f9d/ca0a1/techletter.app-screenshot-1593447820129.webp 223w", "/static/59b33ab01b8e408e98b631b3c2ee4f9d/4430b/techletter.app-screenshot-1593447820129.webp 286w"],
                "sizes": "(max-width: 286px) 100vw, 286px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/59b33ab01b8e408e98b631b3c2ee4f9d/e92b6/techletter.app-screenshot-1593447820129.png 223w", "/static/59b33ab01b8e408e98b631b3c2ee4f9d/357e3/techletter.app-screenshot-1593447820129.png 286w"],
                "sizes": "(max-width: 286px) 100vw, 286px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/59b33ab01b8e408e98b631b3c2ee4f9d/357e3/techletter.app-screenshot-1593447820129.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`We then have a side-effect that watches `}<inlineCode parentName="p">{`state`}</inlineCode>{` for changes and triggers re-renders when needed. This avoids deep re-renders every time we redefine our dispatch methods or whatever.`}</p>
    <p>{`Makes the React tree more stable ✌️`}</p>
    <p>{`Every component rendered within this provider can use this same custom hook to access everything it needs.`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=export%20function%20useSharedCount()%20%7B%0A%20%20const%20%7B%20state%2C%20setSharedCount%20%7D%20%3D%20useContext(SharedCountContext)%3B%0A%0A%20%20function%20incA()%20%7B%0A%20%20%20%20setSharedCount(%22A%22%2C%20state.A%20%2B%201)%3B%0A%20%20%7D%0A%0A%20%20function%20incB()%20%7B%0A%20%20%20%20setSharedCount(%22B%22%2C%20state.B%20%2B%201)%3B%0A%20%20%7D%0A%0A%20%20return%20%7B%20count%3A%20state%2C%20incA%2C%20incB%20%7D%3B%0A%7D"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "638px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "63.22869955156951%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'252\\'%20viewBox=\\'0%200%20400%20252\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M21%2031l-1%2097%201%2095h359v-95l-1-97c-2-2-356-2-358%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/35c615fa2d14f0b1da296e094cc8550a/ca0a1/techletter.app-screenshot-1593447814417.webp 223w", "/static/35c615fa2d14f0b1da296e094cc8550a/75680/techletter.app-screenshot-1593447814417.webp 445w", "/static/35c615fa2d14f0b1da296e094cc8550a/a2d8a/techletter.app-screenshot-1593447814417.webp 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/35c615fa2d14f0b1da296e094cc8550a/e92b6/techletter.app-screenshot-1593447814417.png 223w", "/static/35c615fa2d14f0b1da296e094cc8550a/e66bf/techletter.app-screenshot-1593447814417.png 445w", "/static/35c615fa2d14f0b1da296e094cc8550a/41be6/techletter.app-screenshot-1593447814417.png 638w"],
                "sizes": "(max-width: 638px) 100vw, 638px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/35c615fa2d14f0b1da296e094cc8550a/41be6/techletter.app-screenshot-1593447814417.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`The custom hook taps into React Context for shared state, defines simpler `}<inlineCode parentName="p">{`incA`}</inlineCode>{` and `}<inlineCode parentName="p">{`incB`}</inlineCode>{` helper methods, and returns them with state.`}</p>
    <p>{`That means our `}<inlineCode parentName="p">{`AlternativeClick`}</inlineCode>{` component can look like this:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=import%20%7B%0A%20%20useSharedCount%0A%7D%20from%20%22.%2FSharedCountContextProvider%22%3B%0A%0Aconst%20AlternativeClick%20%3D%20()%20%3D%3E%20%7B%0A%20%20const%20%7B%20count%2C%20incB%20%7D%20%3D%20useSharedCount()%3B%0A%0A%20%20return%20(%0A%20%20%20%20%3Cdiv%20style%3D%7B%7B%20textAlign%3A%20%22left%22%20%7D%7D%3E%0A%20%20%20%20%20%20You%20can%20also%20update%20B%20here%0A%20%20%20%20%20%20%3Cbr%20%2F%3E%0A%20%20%20%20%20%20%3CPrettyButton%20onClick%3D%7BincB%7D%3EB%20%2B1%3C%2FPrettyButton%3E%0A%20%20%20%20%20%20%3Cp%3EIt's%20%7Bcount.B%7D%20btw%3C%2Fp%3E%0A%20%20%20%20%3C%2Fdiv%3E%0A%20%20)%3B%0A%7D%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "534px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "85.20179372197309%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'342\\'%20viewBox=\\'0%200%20400%20342\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M25%2037c-1%202-2%20267%200%20269%201%201%2021%202%20175%202s174-1%20175-2c2-2%201-267%200-269-2-2-348-2-350%200\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/da6876f0020b4b768fa16ada55bb51a3/ca0a1/techletter.app-screenshot-1593447818707.webp 223w", "/static/da6876f0020b4b768fa16ada55bb51a3/75680/techletter.app-screenshot-1593447818707.webp 445w", "/static/da6876f0020b4b768fa16ada55bb51a3/29722/techletter.app-screenshot-1593447818707.webp 534w"],
                "sizes": "(max-width: 534px) 100vw, 534px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/da6876f0020b4b768fa16ada55bb51a3/e92b6/techletter.app-screenshot-1593447818707.png 223w", "/static/da6876f0020b4b768fa16ada55bb51a3/e66bf/techletter.app-screenshot-1593447818707.png 445w", "/static/da6876f0020b4b768fa16ada55bb51a3/a07a7/techletter.app-screenshot-1593447818707.png 534w"],
                "sizes": "(max-width: 534px) 100vw, 534px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/da6876f0020b4b768fa16ada55bb51a3/a07a7/techletter.app-screenshot-1593447818707.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`Gets `}<inlineCode parentName="p">{`count`}</inlineCode>{` and `}<inlineCode parentName="p">{`incB`}</inlineCode>{` from custom hook. Uses them.`}</p>
    <p>{`😍`}</p>
    <h2 {...{
      "id": "what-about-performance"
    }}>{`What about performance?`}</h2>
    <p>{`It's good.`}</p>
    <p>{`Share state as little as possible. Use different context providers for different parts of your app.`}</p>
    <p>{`Don't make it global unless it needs to be global. Wrap the smallest part of your tree that you can get away with.`}</p>
    <p>{`Yes even though it's easier to always wrap everything.`}</p>
    <h2 {...{
      "id": "what-about-complexity"
    }}>{`What about complexity?`}</h2>
    <p>{`What complexity? Keep it small. Don't stuff shit in there that you don't need.`}</p>
    <p>{`That's where the foot shooting starts. When folks put `}<em parentName="p">{`everything`}</em>{` in global state.`}</p>
    <p>{`Also why apps get slow 😉`}</p>
    <h2 {...{
      "id": "i-hate-managing-my-own-state-bleh"
    }}>{`I hate managing my own state, bleh`}</h2>
    <p>{`That's fair. Did you know that this same pattern works with many state management libraries?`}</p>
    <p>{`See that part in our `}<inlineCode parentName="p">{`SharedCountProvider`}</inlineCode>{` that deals with state changes? This part:`}</p>
    <p><a parentName="p" {...{
        "href": "https://carbon.now.sh/?bg=rgba(255,255,255,1)&t=seti&l=javascript&ds=true&wc=true&wa=true&pv=48px&ph=32px&ln=false&code=const%20%5BcontextValue%2C%20setContextValue%5D%20%3D%20useState(%7B%0A%20%20%20%20state%2C%0A%20%20%20%20%2F%2F%20dispatch%20%2F%2F%20from%20your%20reducer%0A%20%20%20%20%2F%2F%20this%20is%20where%20a%20reducer%20comes%20handy%20when%20this%20grows%0A%20%20%20%20setSharedCount%3A%20(key%2C%20val)%20%3D%3E%20%7B%0A%20%20%20%20%20%20setState(state%20%3D%3E%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%20...state%2C%20%5Bkey%5D%3A%20val%20%7D%3B%0A%20%20%20%20%20%20%7D)%3B%0A%20%20%20%20%7D%0A%20%20%20%20%2F%2F%20other%20stuff%20you%20need%20in%20context%0A%20%20%7D)%3B"
      }}><figure parentName="a" {...{
          "className": "gatsby-resp-image-figure",
          "style": {
            "textAlign": "center",
            "fontStyle": "italic"
          }
        }}>{`
    `}<span parentName="figure" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "566px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "64.57399103139014%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'259\\'%20viewBox=\\'0%200%20400%20259\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M24%2035c-2%201-2%20188%200%20190s350%202%20352%200%202-189%200-190H24\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="span">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/48d01dd484e631cffcbe16ad37958c10/ca0a1/techletter.app-screenshot-1593447818164.webp 223w", "/static/48d01dd484e631cffcbe16ad37958c10/75680/techletter.app-screenshot-1593447818164.webp 445w", "/static/48d01dd484e631cffcbe16ad37958c10/3161c/techletter.app-screenshot-1593447818164.webp 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/48d01dd484e631cffcbe16ad37958c10/e92b6/techletter.app-screenshot-1593447818164.png 223w", "/static/48d01dd484e631cffcbe16ad37958c10/e66bf/techletter.app-screenshot-1593447818164.png 445w", "/static/48d01dd484e631cffcbe16ad37958c10/6fe44/techletter.app-screenshot-1593447818164.png 566w"],
                "sizes": "(max-width: 566px) 100vw, 566px",
                "type": "image/png"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/48d01dd484e631cffcbe16ad37958c10/6fe44/techletter.app-screenshot-1593447818164.png",
                "alt": "Click through for source",
                "title": "Click through for source",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
            "className": "gatsby-resp-image-figcaption"
          }}>{`Click through for source`}</figcaption>{`
  `}</figure></a></p>
    <p>{`You can use XState for that. Or a reducer. Or even Redux, if you really want to.`}</p>
    <p>{`Altho if you're using Redux you might as well go all the way 😛`}</p>
    <h2 {...{
      "id": "does-this-really-scale-up-and-down-all-sorts-of-apps"
    }}>{`Does this really scale up and down all sorts of apps?`}</h2>
    <p>{`Yes. Try it.`}</p>
    <p>{`Cheers,`}<br parentName="p"></br>{`
`}{`~Swizec`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      